export enum HydroStressLevel {
    LOW = "low",
    MEDIUM = "medium",
    HIGH = "high",
    UNDEFINED = "undefined",
    VERY_HIGH = "very_high"
}